import React from 'react'
import classNames from 'classnames'
import { DescriptionProps } from './Description.d'

// Component's Render Function with Props
// todo - change variation to 'default', and update OTL pages where necessary
const Description = ({
  tagEl = 'p',
  variation = 'otl-light',
  classes,
  children,
  componentClass
}: DescriptionProps) => {
  const DesctiptionElm = tagEl
  const styleClasses = classRules(variation, classes, componentClass)

  return (
    <DesctiptionElm
      className={styleClasses}
      dangerouslySetInnerHTML={{ __html: children }}
      data-testid='mds-description'
    />
  )
}

// Create ClassName Object for Styles
const classRules = (
  variation: string,
  classes?: string,
  componentClass?: string
) =>
  classNames(classes, componentClass, 'items-center', {
    // OTL Styles
    'font-calibre text-sm text-[#8a8a8a] font-semibold leading-[110%]':
      variation === 'otl-quote-card',
    // Styles for otl-grey
    'font-calibre font-normal text-xs text-legacy-grey-10':
      variation === 'otl-light-sm',
    // Styles for otl-orange
    'font-calibre font-normal text-lg text-legacy-grey-10':
      variation === 'otl-light',
    'font-sansPro font-normal text-lg leading-6 tracking-[0.18px] text-legacy-grey-10':
      variation === 'otl-light-sansPro',
    'font-calibre font-normal text-xl text-legacy-grey-10':
      variation === 'otl-how-to-cta',
    'font-serif font-normal text-base text-legacy-grey-10':
      variation === 'otl-light-georgia',
    'font-serif font-normal text-lg text-legacy-grey-10':
      variation === 'otl-light-georgia-lg',
    'font-calibre font-normal text-sm md:text-xl text-legacy-grey-10':
      variation === 'otl-light-xl',
    // Styles for otl-gray
    'font-calibre font-normal text-lg text-otl-gray': variation === 'otl-gray',
    'font-serif font-normal text-lg text-otl-gray':
      variation === 'otl-gray-georgia',
    // Styles for otl-dark small
    'font-calibre font-normal text-xs text-white': variation === 'otl-dark-sm',
    'font-calibre font-normal text-sm md:text-lg text-otl-sand-2':
      variation === 'otl-dark-lg',
    'font-calibre font-normal text-sm md:text-xl text-otl-sand-2':
      variation === 'otl-dark-md',
    // Styles for otl-dark
    'font-calibre font-normal text-sm text-white': variation === 'otl-dark',
    'font-serif font-normal text-lg text-white':
      variation === 'otl-dark-georgia',
    'font-sansPro font-light text-lg md:text-xl text-white':
      variation === 'otl-dark-xl',
    'font-sansPro font-light text-lg md:text-2xl text-white':
      variation === 'otl-dark-2xl',

    // MDS styles
    'text-base font-normal leading-normal font-sansPro tracking-normal':
      variation === 'default',
    'text-xs font-normal leading-4 font-sansPro': variation === 'caption',
    'text-xs font-normal leading-4 font-sansPro tracking-widest uppercase':
      variation === 'overline',
    'text-xs font-semibold leading-[14px] font-sansPro tracking-[1.2px] uppercase text-black':
      variation === 'badge'
  })

// Export Render Function
export default Description
